import React from "react";

import { Button } from "../../JobsPage/components/Button";

const GmailConnectAccess = () => {
	const CLIENT_ID = "1095773448955-oisqr8utpugqn6lasose3l5nlf5n2nvh.apps.googleusercontent.com"; //93808875822-a5abnkgk4q697uiikdg9vipvdl3cl2rl.apps.googleusercontent.com
	const REDIRECT_URI = "https://www.dproz.com/email-auth-callback?provider=gmail"; //http://localhost:3000/email-auth-callback?provider=gmail

	// local Settings
	// const CLIENT_ID = "93808875822-a5abnkgk4q697uiikdg9vipvdl3cl2rl.apps.googleusercontent.com";
	// const REDIRECT_URI = "http://localhost:3000/email-auth-callback?provider=gmail";

	const handleOnSubmit = () => {
		const scope = "https://www.googleapis.com/auth/gmail.send email";

		window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(
			REDIRECT_URI,
		)}&response_type=code&scope=${encodeURIComponent(scope)}&access_type=offline&prompt=consent`;
	};

	return (
		<Button
			className="inline-flex min-w-fit items-center justify-center bg-primary-700 text-white px-4 h-9 rounded hover:bg-primary-800 transition-colors duration-300 text-sm font-inter w-[90px] group relative overflow-hidden"
			onClick={handleOnSubmit}
		>
			Connect Gmail
		</Button>
	);
};

export default GmailConnectAccess;
